<resetpassword-page>
  <resetpassword-feature />
  <script>
    import './style.scss'
    import 'tags/features/resetpassword-feature'
  </script>
</resetpassword-page>